import { action, makeObservable, observable } from 'mobx'
import { ClientTab, HomeScreenWidget, ImageBackground, Project, ProjectFeatures } from '~/models'
import { ResourceFormModel } from '~/ui/resources/form'

export default class ProjectSettingsFormModel extends ResourceFormModel<Project> {

  constructor(
    public readonly project: Project,
  ) {
    super(Project, project)
    this.appFeatures       = {...project.appFeatures}
    this.clientTabs        = [...project.clientTabs]
    this.homeScreenWidgets = [...project.homeScreen.widgets]

    makeObservable(this)
  }

  @observable
  public appFeatures: ProjectFeatures

  @observable
  public clientTabs: ClientTab[]

  @observable
  public homeScreenWidgets: HomeScreenWidget[]

  @action
  private getAppFeatureEnabled(name: string) {
    return this.appFeatures[name]?.enabled ?? false
  }

  @action
  private setAppFeatureEnabled(name: string, enabled: boolean) {
    if (enabled) {
      this.appFeatures[name] = {enabled: true, options: {}}
    } else {
      delete this.appFeatures[name]
    }
  }

  public override assign(updates: AnyObject) {
    for (const [name, value] of Object.entries(updates)) {
      if (/^appFeatures\.(.+)\.enabled$/.test(name)) {
        this.setAppFeatureEnabled(RegExp.$1, value)
      } else {
        super.assign({[name]: value})
      }
    }
  }

  public override getValue(name: string) {
    if (/^appFeatures\.(.+)\.enabled$/.test(name)) {
      return this.getAppFeatureEnabled(RegExp.$1)
    } else {
      return super.getValue(name as any)
    }
  }

  //------
  // Submit

  protected override buildData() {
    const heroImage = this.getValue('homeScreen.hero.background.image')
    return {
      ...super.buildData(),
      appFeatures: this.appFeatures,
      clientTabs:  this.clientTabs,
      homeScreen:  {
        ...this.project.homeScreen,
        widgets: this.homeScreenWidgets,
        hero: {
          ...this.project.homeScreen.hero,
          welcomeMessage: this.getValue('homeScreen.hero.welcomeMessage'),
          search:         this.getValue('homeScreen.hero.search'),
          background:     heroImage == null ? null : {
            type:   'image',
            image:  heroImage,
            darken: this.getValue('homeScreen.hero.background.darken'),
            fade:   this.getValue('homeScreen.hero.background.fade'),
          } as ImageBackground,
        },
      },
    }
  }

}